import { useState } from 'react';

type Option = {
  label: string;
  value: string;
};

type Props = {
  options: Record<string, string>[];
  disabled?: boolean;
  className?: string;
  getLabel: any;
};

export default function RankingTypeInput({ options, disabled, className, getLabel }: Props) {
  const [items, setItems] = useState(options);
  const [dragIndex, setDragIndex] = useState<number | null>(null);

  const handleDragStart = (index: number) => {
    setDragIndex(index);
  };

  const handleDrop = (index: number) => {
    if (dragIndex === null) return;

    const newItems = [...items];
    const draggedItem = newItems[dragIndex];

    newItems.splice(dragIndex, 1);
    newItems.splice(index, 0, draggedItem);

    setItems(newItems);
    setDragIndex(null);
  };

  return (
    <div className="space-y-3">
      {items.map((opt, index) => (
        <div
          key={opt.value}
          draggable={!disabled}
          onDragStart={() => handleDragStart(index)}
          onDragOver={(e) => e.preventDefault()}
          onDrop={() => handleDrop(index)}
          className="flex items-center gap-3"
        >
          {/* drag dots */}
          <div className="flex flex-col gap-[4px]">
            <span className="w-[6px] h-[6px] bg-[#C0275E] rounded-full"></span>
            <span className="w-[6px] h-[6px] bg-[#C0275E] rounded-full"></span>
            <span className="w-[6px] h-[6px] bg-[#C0275E] rounded-full"></span>
          </div>

          {/* option card */}
          <div className={`flex-1 cursor-move ${className}`}>{getLabel(opt)}</div>
        </div>
      ))}
    </div>
  );
}
